import React from "react";
import { FiAlertTriangle, FiCheckCircle, FiTrendingDown } from "react-icons/fi";

const STATUS_META = {
  ON_TRACK: { label: "On Track", className: "border-emerald-200 bg-emerald-50 text-emerald-700", Icon: FiCheckCircle },
  AT_RISK: { label: "At Risk", className: "border-amber-200 bg-amber-50 text-amber-700", Icon: FiAlertTriangle },
  BEHIND: { label: "Behind", className: "border-rose-200 bg-rose-50 text-rose-700", Icon: FiTrendingDown },
};

export const getPerformanceStatusMeta = (code, label) =>
  STATUS_META[code] || Object.values(STATUS_META).find((item) => item.label === label) || STATUS_META.BEHIND;

export default function PerformanceStatusBadge({ code, label, reason, compact = false }) {
  const meta = getPerformanceStatusMeta(code, label);
  const Icon = meta.Icon;
  return (
    <span
      title={reason || meta.label}
      className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${compact ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs"} ${meta.className}`}
    >
      <Icon className="shrink-0" />
      {meta.label}
    </span>
  );
}
